import { ListOfRoles } from "./Roles.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum RolesActionsTypes {
  CREATE_REQUEST = "roles/CREATE_REQUEST",
  CREATE_FAIL = "roles/CREATE_FAIL",
  CREATE_SUCCESS = "roles/CREATE_SUCCESS",
  DISMISS_MESSAGE = "roles/DISMISS_MESSAGE",
  EDIT_REQUEST = "roles/EDIT_REQUEST",
  EDIT_FAIL = "roles/EDIT_FAIL",
  EDIT_SUCCESS = "roles/EDIT_SUCCESS",
  LIST_REQUEST = "roles/LIST_REQUEST",
  LIST_FAIL = "roles/LIST_FAIL",
  LIST_SUCCESS = "roles/LIST_SUCCESS"
}

export interface RolesState {
  isLoadingList: boolean;
  list?: ListOfRoles;
  message?: IMessageBar;
}

interface CreateRequest {
  type: RolesActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: RolesActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: RolesActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: RolesActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: RolesActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: RolesActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: RolesActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: RolesActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: RolesActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: RolesActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfRoles;
  };
}

export type RolesReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
